import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { isTenantAccessLostError } from './app/services/tenant/tenant-access-lost.error';
import { AppUpgradeService } from './app/services/app-upgrade/app-upgrade.service';

// This will be replaced with the current app version in CI pipeline.
globalThis.appVersion = '1.42';
globalThis.isPwa = true;

if (environment.production && globalThis.appVersion !== 'Preview Version') {
  Sentry.init({
    dsn: 'https://e071362d5c148e2d3d2e8196c96ec835@o4510053345329152.ingest.de.sentry.io/4510053350309968',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    // Disable it for now as we don't need it yet and to respect user privacy.
    sendDefaultPii: false,
    release: globalThis.appVersion,

    integrations: [Sentry.replayIntegration()],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend(event, hint) {
      // Expected flow (lost access to an organization), already shown to the user.
      if (isTenantAccessLostError(hint?.originalException)) {
        return null;
      }
      // Filtere sensible Daten aus dem Event
      if (event.user) {
        delete event.user.email;
        delete event.user.username;
        delete event.user.ip_address;
      }
      return event;
    },
  });
}

new AppUpgradeService().runUpgrade().finally(() => {
  // Wait for upgrade check to complete before launching the app.
  // Even start when check fails.
  if (environment.production) {
    enableProdMode();
  }

  platformBrowser()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
});
